import { Descriptions } from "antd"
import mechnical from "../../../Assets/Img/mechnical.webp"
import batch from "../../../Assets/Img/mechnical.webp"
import accountant from "../../../Assets/Img/accountant.webp"
import nlp from "../../../Assets/Img/nlp.webp"
import master from "../../../Assets/Img/master.webp"
import thinking from "../../../Assets/Img/thinking.webp"
import coaching from "../../../Assets/Img/coaching.webp"
import members from "../../../Assets/Img/members.jpeg"
import ebay from "../../../Assets/Img/ebay.jpeg"
import oracle from "../../../Assets/Img/oracle.jpeg"



const Data=[
    {
        Img:mechnical,
        heading:"Mechanical Engineering, MEng (Imperial College London)"
      
    },
    {
        Img:accountant,
        heading:"Chartered Accountant ",
        text:"(Chartered Institute of Management Accountants, CIMA)"
     
        
    },
    {
        Img:ebay,
        heading:"eBay Powerseller status (2006-2010)",
        
    },
    {
        Img:oracle,
        heading:"SAP & Oracle superuser (2007-2010)Real Time Tracking"
       
    },
    {
        Img:nlp,    
        heading:"Certified Master Coach and Practitioner of Neuro-Linguistic Programming (ABNLP)"
        
    },
    {
        Img:master,
        heading:"Certified Master Practitioner of Hypnotherapy (ABH)"
        
    },
    {
        Img:thinking,
        heading:"Certified Master Practitioner of Time Line Therapy® Techniques",
        
    },
    {
        Img:coaching,
        heading:"Certified Practitioner of Language and Behaviour (LAB) Profile for Coaching "
        
    },
    {
        Img:members,
        heading:"Certified Member of the International Association of Counsellors & Therapist (IACT)",
        
    },
]
export default Data;